
import React, { useState, useEffect } from 'react';
import { GB, ES } from 'country-flag-icons/react/3x2';

const LanguageSelector = () => {
  const [selectedLanguage, setSelectedLanguage] = useState('en');

  useEffect(() => {
    const storedLanguage = localStorage.getItem('language');
    if (storedLanguage) {
      setSelectedLanguage(storedLanguage);
    }
  }, []);

  const handleLanguageChange = (language) => {
    setSelectedLanguage(language);
    localStorage.setItem('language', language);
    window.location.reload();
  };

  return (
    <div className="flex items-center">
      <button
        className={`flex items-center text-black hover:text-secondary-700 font-bold px-2 py-2 rounded ${selectedLanguage === 'en' ? 'opacity-50' : ''}`}
        onClick={() => handleLanguageChange('en')}
      >
        <GB className="w-6 h-4" />
      </button>
      <button
        className={`flex items-center text-black hover:text-secondary-700 font-bold px-2 py-2 rounded ${selectedLanguage === 'es' ? 'opacity-50' : ''}`}
        onClick={() => handleLanguageChange('es')}
      >
        <ES className="w-6 h-4" />
      </button>
    </div>
  );
};

export default LanguageSelector;
